import React from 'react';
import { useSocketConnection } from '../../hooks/useSocketConnection';

interface SocketConnectionManagerProps {
  user: any;
}

const SocketConnectionManager: React.FC<SocketConnectionManagerProps> = ({ user }) => {
  useSocketConnection(user);
  return null;
};

export default SocketConnectionManager; 